// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__27diw","title":"ClientCherryInfo_title__2kecn","itemText":"ClientCherryInfo_itemText__3mShZ"};